import axios from 'axios';
import config from '../config/config';
import generateAuthHeaders from '../infrastructure/generateAuthHeaders';
import IStore from '../infrastructure/store.interface';
import { Store } from 'redux';

const createAxiosCfg = (opts: $TSFixMe) => {
    if (process.env.NODE_ENV === 'test') {
        Object.assign(opts, { adapter: require('axios/lib/adapters/http') });
    }
    return axios.create(opts);
};

export const localHttpClient = createAxiosCfg({
    baseURL: config.host,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    }
});

export const apiHttpClient = createAxiosCfg({
    baseURL: config.apiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

export const createRequestInterceptors = (options: { store: Store<IStore> }) => {
    apiHttpClient.interceptors.request.use(config => {
        const authHeaders = generateAuthHeaders(options);
        config.headers = { ...config.headers, ...authHeaders };
        return config;
    });
};
